<script lang="ts">import { t, Verbiage } from "@infinitro/content";
import VipBenefitCashback from "./vip-benefit-cashback.svelte";
import VipBenefitFreespins from "./vip-benefit-freespins.svelte";
import VipBenefitLevelUp from "./vip-benefit-level-up.svelte";
import VipBenefitRakeback from "./vip-benefit-rakeback.svelte";
import VipBenefitReferral from "./vip-benefit-referral.svelte";
import VipTitle from "./vip-title.svelte";
</script>

<div class="vip-benefits-container">
	<VipTitle title={$t(Verbiage.vip_benefits_text)} />
	<div class="vip-benefits">
		<VipBenefitCashback />
		<VipBenefitRakeback />
		<VipBenefitLevelUp />
		<VipBenefitReferral />
		<VipBenefitFreespins />
	</div>
</div>

<style>
	.vip-benefits-container {

    display: flex;

    width: 100%;

    flex-direction: column;

    align-items: center;

    gap: 2rem
}

	.vip-benefits {

    display: flex;

    width: 100%;

    flex-direction: column;

    align-items: center;

    gap: 2rem
}
</style>
